var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddWhiteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Add Icon",
    d: "M8.93975 3.93975H5.56025V0.56025C5.56025 0.411662 5.50122 0.269161 5.39616 0.164093C5.29109 0.059026 5.14859 0 5 0C4.85141 0 4.70891 0.059026 4.60384 0.164093C4.49878 0.269161 4.43975 0.411662 4.43975 0.56025V3.93975H1.06025C0.911662 3.93975 0.769161 3.99878 0.664093 4.10384C0.559026 4.20891 0.5 4.35141 0.5 4.5C0.5 4.64859 0.559026 4.79109 0.664093 4.89616C0.769161 5.00122 0.911662 5.06025 1.06025 5.06025H4.43975V8.43975C4.43975 8.58834 4.49878 8.73084 4.60384 8.83591C4.70891 8.94097 4.85141 9 5 9C5.14859 9 5.29109 8.94097 5.39616 8.83591C5.50122 8.73084 5.56025 8.58834 5.56025 8.43975V5.06025H8.93975C9.08834 5.06025 9.23084 5.00122 9.33591 4.89616C9.44097 4.79109 9.5 4.64859 9.5 4.5C9.5 4.35141 9.44097 4.20891 9.33591 4.10384C9.23084 3.99878 9.08834 3.93975 8.93975 3.93975V3.93975Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWhiteIcon);
export default __webpack_public_path__ + "static/media/addWhiteIcon.e489c7a393fd8f801bb8a5895764c0d3.svg";
export { ForwardRef as ReactComponent };